<template>
  <div class="mb-3">
    <div class="d-flex flex-row">
      <h4 class="left-side">{{ $t('exportPrompt.imageQuality') }}</h4>
      <drop-down
          :initial-active-value="value"
          :labels="labels"
          :values="qualities"
          class="w-75"
          @select="$emit('input', $event)"
      />
    </div>
    <div class="lighter mt-1">{{ $t('exportPrompt.imageQualityHint') }}</div>
  </div>
</template>

<script>
import DropDown from '@/components/forms/DropDown.vue';
import {DEFAULT_EXPORT_IMAGE_QUALITY, EXPORT_IMAGE_PROFILES} from './exportImageQuality';

export default {
  name: 'ImageQualitySelector',
  components: {DropDown},
  props: {value: {type: String, default: DEFAULT_EXPORT_IMAGE_QUALITY}},
  data() {
    return {qualities: Object.keys(EXPORT_IMAGE_PROFILES)};
  },
  computed: {
    labels() {
      return this.qualities.map(quality => this.$t(`exportPrompt.imageQualityLevels.${quality}`));
    },
  },
};
</script>
